import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
/**
 * Shown the first time a player opens a battle they haven't picked a deck
 * for themselves — most notably the opponent, whose deck slot
 * CreateBattleController auto-locks from their most-recently-saved complete
 * deck rather than asking (see SelectBattleDeckController's class doc).
 * Same auto-open-on-entering-the-battle pattern as RespondDrawModal.
 */
export default class SelectBattleDeckModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", false);
    _defineProperty(this, "loadingDecks", true);
    _defineProperty(this, "error", null);
    _defineProperty(this, "readyDeckSlots", []);
    _defineProperty(this, "selectedDeckSlotId", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loadDeckSlots();
  }
  async loadDeckSlots() {
    this.loadingDecks = true;
    m.redraw();
    try {
      var _response$slots, _this$readyDeckSlots$, _this$readyDeckSlots$2;
      const response = await app.request({
        method: 'GET',
        url: "".concat(app.forum.attribute('apiUrl'), "/arena/deck-slots")
      });
      const slots = (_response$slots = response == null ? void 0 : response.slots) != null ? _response$slots : [];
      this.readyDeckSlots = slots.filter(s => s.cardCount === 20);
      const current = this.attrs.currentDeckSlotId;
      this.selectedDeckSlotId = current !== null && this.readyDeckSlots.some(s => s.id === current) ? current : (_this$readyDeckSlots$ = (_this$readyDeckSlots$2 = this.readyDeckSlots[0]) == null ? void 0 : _this$readyDeckSlots$2.id) != null ? _this$readyDeckSlots$ : null;
    } catch (_unused) {
      this.readyDeckSlots = [];
      this.selectedDeckSlotId = null;
    } finally {
      this.loadingDecks = false;
      m.redraw();
    }
  }
  className() {
    return 'ArenaSelectDeckModal Modal--small';
  }
  title() {
    return m('[', null, m("i", {
      className: "fas fa-layer-group"
    }), " ", app.translator.trans('forumaker-arena.forum.select_deck_modal.title'));
  }
  content() {
    var _this$selectedDeckSlo;
    const hasDeck = !this.loadingDecks && this.readyDeckSlots.length > 0;
    return m("div", {
      className: "Modal-body"
    }, m("p", {
      className: "ArenaSelectDeckModal-text"
    }, app.translator.trans('forumaker-arena.forum.select_deck_modal.text')), this.error && m("div", {
      className: "Alert Alert--error",
      style: {
        marginBottom: '12px'
      }
    }, m("i", {
      className: "fas fa-exclamation-circle"
    }), " ", this.error), !hasDeck && !this.loadingDecks && m("div", {
      className: "Alert Alert--warning",
      style: {
        marginBottom: '12px'
      }
    }, m("i", {
      className: "fas fa-exclamation-triangle"
    }), ' ', app.translator.trans('forumaker-arena.forum.challenge_modal.no_deck'), ' ', m("a", {
      className: "ArenaSelectDeckModal-buildDeckLink",
      href: "#",
      onclick: e => {
        var _app$session$user$use, _app$session$user;
        e.preventDefault();
        this.hide();
        m.route.set(app.route('user.arena', {
          username: (_app$session$user$use = (_app$session$user = app.session.user) == null ? void 0 : _app$session$user.username()) != null ? _app$session$user$use : ''
        }));
      }
    }, app.translator.trans('forumaker-arena.forum.challenge_modal.build_deck'))), hasDeck && m("div", {
      className: "Form-group ArenaSelectDeckModal-deckWrap"
    }, m("label", null, app.translator.trans('forumaker-arena.forum.challenge_modal.deck_label')), m("select", {
      className: "FormControl",
      value: (_this$selectedDeckSlo = this.selectedDeckSlotId) != null ? _this$selectedDeckSlo : '',
      onchange: e => {
        this.selectedDeckSlotId = parseInt(e.target.value, 10);
      }
    }, this.readyDeckSlots.map(slot => m("option", {
      key: slot.id,
      value: slot.id
    }, slot.name)))), m("div", {
      className: "Form-group ArenaSelectDeckModal-submitGroup"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      loading: this.loading,
      disabled: !hasDeck || this.selectedDeckSlotId == null || this.loading,
      onclick: () => this.submit()
    }, app.translator.trans('forumaker-arena.forum.select_deck_modal.choose_btn'))));
  }
  async submit() {
    if (this.selectedDeckSlotId == null) return;
    this.loading = true;
    this.error = null;
    m.redraw();
    try {
      var _this$attrs$onSelecte, _this$attrs;
      await app.request({
        method: 'POST',
        url: "".concat(app.forum.attribute('apiUrl'), "/arena/battles/").concat(this.attrs.battle.id(), "/select-deck"),
        body: {
          deckSlotId: this.selectedDeckSlotId
        }
      });
      this.hide();
      (_this$attrs$onSelecte = (_this$attrs = this.attrs).onSelected) == null || _this$attrs$onSelecte.call(_this$attrs, this.selectedDeckSlotId);
    } catch (e) {
      var _ref, _ref2, _e$response, _e$response2, _ref3, _body$error, _body$errors;
      const body = (_ref = (_ref2 = (_e$response = e == null ? void 0 : e.response) != null ? _e$response : e == null || (_e$response2 = e.response) == null ? void 0 : _e$response2.body) != null ? _ref2 : e == null ? void 0 : e.responseJSON) != null ? _ref : {};
      // No dedicated locale key for this: the server always replies with its
      // own localized {error} on the validation paths that can actually
      // trigger here (deck incomplete, already played), so this fallback is
      // only ever reached on an unexpected/network failure — Flarum core's
      // generic error string covers that.
      this.error = (_ref3 = (_body$error = body == null ? void 0 : body.error) != null ? _body$error : body == null || (_body$errors = body.errors) == null || (_body$errors = _body$errors[0]) == null ? void 0 : _body$errors.detail) != null ? _ref3 : app.translator.trans('core.lib.error.generic_message');
      this.loading = false;
      m.redraw();
    }
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/SelectBattleDeckModal', SelectBattleDeckModal);